import axios from "axios";

export default class BaseService {

    url = null;
    constructor(url) {
        this.url = url;
    }
    addItem = (payload) => {
        return axios.post(this.url, payload, {
            timeout: 5000
        })

    }

    deleteItem = (id) => {
        return axios.delete(this.url, {
            timeout: 5000,
            params: {
                id: id
            }
        })

    }

}